import * as React from 'react';
import * as styles from './Page.css';

export const Page = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['page']}>{props.children}</div>;
};
